module.exports = "./img/b967ac42e68a95873302f93fd7144539.jpg";